import { componentsStateType } from "reducer/types";

  export const SET_COMPONENTS_STATE = (payload: componentsStateType) => ({
    type: 'SET_COMPONENTS_STATE',
    payload: payload
  });  


  export const SET_LANG = (payload: string) => ({
    type: 'SET_LANG',
    payload: payload
  });  


  export const SET_FOLLOW_LINK = (payload: string) => ({
    type: 'SET_FOLLOW_LINK',
    payload: payload
  });  


  

   
  
  
  